module.exports = __webpack_public_path__ + "static/img/newsPic0.b3f1a25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newsPic0.png
// module id = feGM
// module chunks = 1